/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const settingsHolderDetailConfig = {
  searchPlaceholderText: 'Search Policy by Name',
  searchStatusFilter: [
    {
      value: 'all',
      label: 'Any Status',
    },
    {
      value: 'pending',
      label: 'Pending',
    },
    {
      value: 'active',
      label: 'Active',
    },
    {
      value: 'suspended',
      label: 'Suspended',
    },
  ],
  settingsEntries: [
    {
      value: '10',
      label: '10',
    },
    {
      value: '20',
      label: '20',
    },
    {
      value: '30',
      label: '30',
    },
  ],
};
